import React, { useState } from "react";
import apiHelper from "../../../../util/ApiHelper";
import { useLoading } from "../../../../util/LoadingProvider";
import { Box, Grid, Typography } from "@material-ui/core";
import { toast } from "react-toastify";
import { modal } from "../../../../util";
import { Link } from "react-router-dom";
import LogoGroupForm from "./logoGroupForm";
import DragAndDropTable from "../../../common/DragAndDropTable";

export default function LogoGroupPage(props) {
  const { disabled, match } = props;
  const [globalFilter, setGlobalFilter] = useState("");
  const [isSearched, setIsSearched] = useState(false);
  const [orderingDisabled, setOrderingDisabled] = useState(false);
  const [rows, setRows] = useState([]);
  const [searchString, setSearchString] = useState("");
  const { setLoading } = useLoading();
  const [pageSize, setPageSize] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const getLogoGroups = React.useCallback(async () => {
    try {
      setLoading(true);
      const result = await apiHelper.hkiff.getLogoGroups(
        null,
        pageIndex,
        (pageIndex + 1) * pageSize,
        pageSize,
        searchString
      );
      console.log(result);
      setRows(result.data.content.filter((x) => x));
      setTotalElements(result.data.totalElements);
      setTotalPages(result.data.totalPages);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [pageIndex, pageSize, searchString, setLoading]);

  React.useEffect(() => {
    if (pageSize) getLogoGroups();
  }, [getLogoGroups]);

  const handleSorting = (bool) => {
    if (!isSearched) {
      setOrderingDisabled(bool);
    }
  };

  const handleSearch = (searchString) => {
    setGlobalFilter(searchString);
    setIsSearched(true);
    setOrderingDisabled(true);
  };

  const handleDelete = async (id) => {
    const decision = await modal.fire({
      title: "Delete File",
      text: "Are you sure to delete this event?",
      showCancelButton: true,
      confirmButtonText: `Delete`,
    });
    if (decision.isConfirmed) {
      try {
        await apiHelper.hkiff.deleteLogoGroupById(id);
        toast.dark("The event is deleted.");
        await getLogoGroups();
      } catch (err) {
        console.log(err);
      }
    }
  };

  const getMaxSeqInRows = (rows) => {
    let seq = null;
    rows.forEach((e) => {
      if ((e.seq && seq === null) || (seq !== null && e.seq > seq)) {
        seq = e.seq
      }
    })
    return seq;
  }

  const saveOrdering = async () => {
    try {
      const maxSeq = getMaxSeqInRows(rows);
      const seqData = {};
      var size = rows.length;
      rows.forEach((e, i) => {
        seqData[e.id] = maxSeq-size+i+1;
      });
      const result = await apiHelper.hkiff.orderLogoGroups(seqData);
      if (result.data.code === 0) {
        toast.dark("Your changes is saved.");
        await getLogoGroups();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Name (English)",
        accessor: "nameEn",
        Cell: ({ row }) => {
          return (
            <Link
              style={{
                textDecoration: "none",
                color: "#306F9D",
              }}
              to={`${match.url}/${row.original.id}`}
            >
              {row.original.nameEn}
            </Link>
          );
        },
      },
      {
        Header: "Name (Traditional Chinese)",
        accessor: "nameTc",
        Cell: ({ row }) => {
          return (
            <Link
              style={{
                textDecoration: "none",
                color: "#306F9D",
              }}
              to={`${match.url}/${row.original.id}`}
            >
              {row.original.nameTc}
            </Link>
          );
        },
      },
    ],
    []
  );

  return (
    <>
      <Box width="100%">
        <Typography variant="h4" gutterBottom>
          Using Our Logo &gt; Logo Group
        </Typography>
      </Box>
      <Grid container spacing={4}>
        <Grid item xs={4}>
          <LogoGroupForm
            description="Add New Logo Group"
            submitBtnTxt="Add New Group"
            gridSize={4}
            upperBtnGroupSize="75%"
            fetchData={getLogoGroups}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={8}>
          <DragAndDropTable
            globalFilter={globalFilter}
            orderingDisabled={orderingDisabled}
            handleSorting={handleSorting}
            handleSearch={handleSearch}
            searchString={searchString}
            setSearchString={setSearchString}
            fetchData={getLogoGroups}
            data={rows}
            setData={setRows}
            columns={columns}
            bulkDeleteApi={(ids) => Promise.all(ids.map((id) => apiHelper.hkiff.deleteLogoGroupById(id)))}
            subject="event"
            saveOrderingApi={saveOrdering}
            disabled={disabled}
            editDeleteAction={true}
            handleDelete={handleDelete}
            withPagination={true}
            setParentPageSize={setPageSize}
            setParentPageIndex={setPageIndex}
            parentPageIndex={pageIndex}
            totalElements={totalElements}
            totalPages={totalPages}
          />
        </Grid>
      </Grid>
    </>
  );
}
